import axios from 'axios';
import React, { Suspense, useEffect } from 'react';
import BXILogo from './assets/logos/bxi-logo.png';
import { AppProvider } from './Context/AppContext.js';
import LandingRouter from './routes/LandingRouter';
import initializeLimeChatWhatsapp from './utils/initializeLimeChatWhatsapp';
import { getBxiApiKey } from './config/apiKey';


const apiBaseUrl = (process.env.REACT_APP_API_URL || 'https://apiv1production.bxiworld.com').replace(/\/+$/, '');
axios.defaults.baseURL = `${apiBaseUrl}/`;
axios.defaults.headers.bxiapikey = getBxiApiKey();
axios.defaults.withCredentials = true;

// Dashboard URL for cross-project navigation
const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL || 'http://localhost:3001';

// Make dashboard URL available globally
window.DASHBOARD_URL = DASHBOARD_URL;

const Loader = () => {
  return (
    <div
      className='loader'
      style={{
        width: '100vw',
        height: '100vh',
        background: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src={BXILogo}
        width={300}
        height={300}
        style={{ width: '300px', height: '300px' }}
        alt='BXI Logo'
        title='BXI Logo'
      />
    </div>
  );
};

function App() {
  const limeChatScriptId = 'limechat-sdk-script';

  const initializeLimeChat = () => {
    if (typeof window === 'undefined') return;
    const BASE_URL = 'https://app.limechat.ai';

    if (window.chatwootSDK?.run) {
      window.chatwootSDK.run({
        websiteToken: 'HyToUUEYVaDNr1v8UC57A1vz',
        baseUrl: BASE_URL,
      });
      return;
    }

    const existingScript = document.getElementById(limeChatScriptId);
    if (existingScript) {
      return;
    }

    const g = document.createElement('script');
    g.id = limeChatScriptId;
    g.src =
      'https://s3.ap-south-1.amazonaws.com/cdn.limechat.ai/packs/js/LC_sdk/v1/sdk.js';
    g.defer = true;

    const s = document.getElementsByTagName('script')[0];
    if (!s?.parentNode) return;

    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      window.chatwootSDK?.run({
        websiteToken: 'HyToUUEYVaDNr1v8UC57A1vz',
        baseUrl: BASE_URL,
      });
    };
  };

  useEffect(() => {
    const start = () => {
      initializeLimeChat();
      initializeLimeChatWhatsapp();
    };
    let idleId;
    let timer;
    if (typeof window.requestIdleCallback === 'function') {
      idleId = window.requestIdleCallback(start, { timeout: 8000 });
    } else {
      timer = setTimeout(start, 8000);
    }
    return () => {
      if (idleId && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleId);
      }
      if (timer) clearTimeout(timer);
    };
  }, []);

  if (window.self !== window.top) {
    window.top.location = window.self.location;
  }

  return (
    <AppProvider>
      <div className='App'>
        <Suspense fallback={<Loader />}>
          <LandingRouter />
        </Suspense>
      </div>
    </AppProvider>
  );
}

export default App;
